"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYear = exports.getMonth = exports.getWeek = exports.getDay = exports.convertSun2MonWeekday = exports.getIntlDayName = exports.getDayName = exports.getDate = exports.convertDateToDisplayDateString = exports.convertDateToPlatformDateString = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var isDate_1 = tslib_1.__importDefault(require("lodash/isDate"));
var format_1 = tslib_1.__importDefault(require("date-fns/format"));
var constants_1 = require("../constants");
var capitalize_1 = tslib_1.__importDefault(require("lodash/capitalize"));
exports.convertDateToPlatformDateString = function (date) {
    return isDate_1.default(date) ? format_1.default(date, constants_1.PLATFORM_DATE_FORMAT) : date;
};
exports.convertDateToDisplayDateString = function (date, dateFormat) {
    // In schedule email dialog, use date string as sub-fix of attached file name
    // to avoid "/" character in file name
    var DISPLAY_DATE_FORMAT_MAPPER = {
        "MM/dd/yyyy": "MM-dd-yyyy",
        "dd/MM/yyyy": "dd-MM-yyyy",
        "M/d/yy": "M-d-yy",
    };
    var displayDateFormat = DISPLAY_DATE_FORMAT_MAPPER[dateFormat] || dateFormat;
    return isDate_1.default(date) ? format_1.default(date, displayDateFormat) : date;
};
function getDate(date) {
    return date.getDate();
}
exports.getDate = getDate;
function getDayName(date) {
    return format_1.default(date, "eeee");
}
exports.getDayName = getDayName;
function getIntlDayName(intl, startDate) {
    return capitalize_1.default(intl.formatDate(startDate, { weekday: "long" }));
}
exports.getIntlDayName = getIntlDayName;
function convertSun2MonWeekday(dayIndex) {
    return dayIndex === 0 ? 7 : dayIndex;
}
exports.convertSun2MonWeekday = convertSun2MonWeekday;
function getDay(date) {
    return convertSun2MonWeekday(date.getDay());
}
exports.getDay = getDay;
function getWeek(date) {
    return Math.ceil(date.getDate() / 7);
}
exports.getWeek = getWeek;
function getMonth(date) {
    return date.getMonth() + 1;
}
exports.getMonth = getMonth;
function getYear(date) {
    return date.getFullYear();
}
exports.getYear = getYear;
//# sourceMappingURL=datetime.js.map